declare global {
  interface Window {
    grecaptcha?: {
      enterprise?: {
        ready: (callback: () => void) => void;
        execute: (
          siteKey: string,
          options: { action: string },
        ) => Promise<string>;
      };
    };
  }
}

export function executeRecaptcha(
  siteKey: string | undefined,
  action: string,
): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error("reCAPTCHA script is not loaded."));
      return;
    }

    if (!siteKey) {
      reject(new Error("reCAPTCHA Site Key not set."));
      return;
    }

    window.grecaptcha.enterprise!.ready(() => {
      window
        .grecaptcha!.enterprise!.execute(siteKey, { action })
        .then(resolve)
        .catch(reject);
    });
  });
}
